var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Row',{staticClass:"m-b-10",attrs:{"gutter":8}},[_c('i-col',{attrs:{"span":"12"}},[_c('Card',[_c('industry-stat')],1)],1),_c('i-col',{attrs:{"span":"12"}},[_c('Card',[_c('product-stat')],1)],1)],1),_c('Card',{staticClass:"m-b-10"},[_c('station-stat')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }